import React from 'react';
import { useTTS } from '../context/TTSContext';

interface TTSToggleProps {
    className?: string;
}

const TTSToggle: React.FC<TTSToggleProps> = ({ className = '' }) => {
    const { ttsEnabled, toggleTTS } = useTTS();

    return (
        <button
            onClick={toggleTTS}
            className={`nes-btn health-control-btn ${className} ${ttsEnabled ? 'is-success' : 'is-error'}`}
            aria-label={ttsEnabled ? 'Disable text-to-speech' : 'Enable text-to-speech'}
            title={ttsEnabled ? 'Text-to-speech is ON' : 'Text-to-speech is OFF'}
        >
            {ttsEnabled ? '🗣️' : '🗣️'}
        </button>
    );
};

export default TTSToggle;
